import { DeviceCategory } from 'mobily-ui-library'
import { useTranslation } from 'react-i18next'
import { Highlight, connectRefinementList } from 'react-instantsearch-dom'

import Accessories from '../../assets/DeviceCategories/Accessories.png'
import Consoles from '../../assets/DeviceCategories/Consoles.png'
import Laptops from '../../assets/DeviceCategories/Laptops.png'
import Phones from '../../assets/DeviceCategories/Phones.png'
import Routers from '../../assets/DeviceCategories/Routers.png'
import Tablets from '../../assets/DeviceCategories/Tablets.png'
import Wearables from '../../assets/DeviceCategories/Wearables.png'
import { useScroll } from '../../functions/useScroll'
import './DeviceCategories.scss'
import { useEffect } from 'react'

const RefinementList = ({
  items,
  isFromSearch,
  refine,
  createURL,
}: {
  items: any
  isFromSearch: any
  refine: any
  createURL: any
}) => {
  const { t } = useTranslation()
  const { scrollY } = useScroll();
  const win: any = window;

  useEffect(() => {
    try {
      const defaultCategory = 'Phones';
      win?.MixpanelTracker?.trackEvent("Device Category Selected", {
        selected_category: defaultCategory,
      });
    } catch (e) {
      console.log("Mixpanel Error:", e);
    }
  }, []);

  const categoryImages: any = {
    'Phones': Phones,
    'Tablets': Tablets,
    'Wearables': Wearables,
    'Consoles': Consoles,
    'Laptops': Laptops,
    'Routers': Routers,
    'Accessories': Accessories
  }

  const categoryLabels: any = {
    'Smart Phones': 'Phones',
    'الهواتف الذكية': 'Phones',
    'Tablets': 'Tablets',
    'لوح': 'Tablets',
    'Smart Watches': 'Wearables',
    'الساعات الذكية': 'Wearables',
    'Laptops': 'Laptops',
    'حاسوب محمول': 'Laptops',
    'Consoles': 'Consoles',
    'ألعاب إلكترونية': 'Consoles',
    'Accessories': 'Accessories',
    'مُكَمِّلات': 'Accessories',
    'Routers': 'Routers',
    'جهاز التوجيه': 'Routers'
  }

  const highlightStyle = {
    backgroundColor: 'rgba(0, 140, 255, 0.1)',
    border: '1px solid #008CFF',
  }

  const normalStyle = {
    backgroundColor: '#FFFFFF',
    border: '1px solid #D5D8DF',
  }

  const handleCategoryClick = (item: any) => {
    if (item.isRefined) return;
    try {
      const selectedCategory = categoryLabels[item.label];
      win?.MixpanelTracker?.trackEvent("Device Category Selected", {
        selected_category: selectedCategory,
      });
    } catch (e) {
      console.log("Mixpanel Error:", e);
    }
  };

  return (
    <div className="deviceCategories_container">
      <ul className={`deviceCategories ${scrollY > 100.00 ? 'fixedTopPosition' : ''}`}>
        {items.map(
          (item: any) => {
            return (
              <li key={item.label}>
                <a
                  className="deviceFilter"
                  href={createURL(item.value)}
                  onClick={event => {
                    event.preventDefault()
                    refine(item.value);
                    handleCategoryClick(item);
                  }}
                >
                  {isFromSearch ? (
                    <Highlight attribute="label" hit={item} />
                  ) : (
                    scrollY > 100.00 ?
                      <div
                        className="categoryLabel"
                        style={item.isRefined ? highlightStyle : normalStyle}>
                        {t(categoryLabels[item.label])}
                      </div> :
                      <DeviceCategory
                        image={categoryImages[categoryLabels[item.label]]}
                        label={t(categoryLabels[item.label])}
                        isRefined={item.isRefined}
                        alt={item.label}
                      />
                  )}
                </a>
              </li>
            )
          }
        )}
      </ul>
    </div>
  )
}

const RefinedCategories = connectRefinementList(RefinementList)

export default RefinedCategories
